import { GreenCtaButton } from '../../components/atomic/buttons/green_cta_button/GreenCtaButton';
import textImg from './text.png';

type ButtonProps = {
  onClick?: () => void;
};

/** Welcome 1 continue CTA. */
export function Button({ onClick }: ButtonProps) {
  return (
    <GreenCtaButton
      textSrc={textImg}
      ariaLabel="Продолжить"
      onClick={onClick}
      left={228}
      width={625}
      gradient={{ sizeX: 416.136, sizeY: 977.585, atX: 312.5, atY: 86.5 }}
      flash={{ left: 590.157, top: 14.996 }}
      textSize={{ width: 439, height: 104 }}
    />
  );
}
